export const Loading = ({ message = 'Загрузка...' }) => (
  <div className="flex flex-col items-center justify-center p-8">
    <div className="animate-spin text-4xl mb-4">⚙️</div>
    <p className="text-gray-600">{message}</p>
  </div>
)